import type { State } from '../types.tsx';
import { createIssueHook } from './utils.tsx';

export const useOpenUpdateCounter = createIssueHook((state: State) => state.openUpdateCounter);
